module.exports = __webpack_public_path__ + "static/media/proj18_img3.5bbbe8cb.jpg";